import React from "react";
import "../css/QuickLinks.css";
import mou from "../image/mou-logo.png";
import nss from "../image/nss-logo.png";
import nats from "../image/nats-logo.png";

function App() {
  // Predefined valid URLs (replace with actual paths)
  const links = {
    achievements: "/achievements",
    auditReports: "/audit-reports",
    bestPractices: "/best-practices",
    gallery: "/gallery",
    feedback: "/feedback",
    holidays: "/holidays",
    infrastructure: "/infrastructure",
    innovation: "/innovation-cell",
    iso: "/iso-certificate",
    jobs: "/job-opportunities",
    magazine: "/magazine",
    placements: "/placements",
    events: "/events",
    syllabus: "/syllabus",
    clc: "/clc-certificate",
    transfer: "/transfer-certificate",
    character: "/character-certificate",
    mou: "/mou",
    nss: "/nss",
    nats: "/nats",
  };

  return (
    <div className="box">
      {/* Quick Links */}
      <div className="column quick-links">
        <h2>Quick Links</h2>
        <ul>
          {[
            { text: "🏆Achievements", url: links.achievements },
            { text: "📁Audit Reports", url: links.auditReports },
            { text: "✒️Best Practises", url: links.bestPractices },
            { text: "🖼️Gallery", url: links.gallery },
            { text: "🗣️Grievance & Feedback", url: links.feedback },
            { text: "📅Holiday List 2025", url: links.holidays },
            { text: "🏗️Infrastructure", url: links.infrastructure },
            { text: "💡Innovation Cell", url: links.innovation },
            { text: "📜ISO Certificate", url: links.iso },
            { text: "💼Job Opportunities", url: links.jobs },
            { text: "📖Magazine & Journal", url: links.magazine },
            { text: "🎓Placements", url: links.placements },
            { text: "🎤Seminar & Conference", url: links.events },
            { text: "📘Syllabus", url: links.syllabus },
          ].map((item, index) => (
            <li key={index}>
              <a href={item.url}>{item.text}</a>
            </li>
          ))}
        </ul>
      </div>

      {/* Useful Links (Cards) */}
      <div className="column useful-links">
        <h2>Useful Links</h2>
        <div className="cards">
          {[
            { name: "Memorandum Of Understanding", image: mou, url: links.mou },
            { name: "National Service Scheme", image: nss, url: links.nss },
            {
              name: "National Apprenticeship Training Scheme",
              image: nats,
              url: links.nats,
            },
          ].map((card, index) => (
            <a href={card.url} key={index} className="card-link">
              <div className="card">
                <img src={card.image} alt={card.name} />
                <p>{card.name}</p>
              </div>
            </a>
          ))}
        </div>
      </div>

      <div className="column apply-form">
        <h2>Online Apply Form</h2>
        <ul>
          <li>
            <a href={links.clc}>📝CLC Certificate Form</a>
          </li>
          <li>
            <a href={links.transfer}>📄Transfer Certificate</a>
          </li>
          <li>
            <a href={links.character}>📃Character Certificate</a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default App;
